import type { PostProcessorModule } from 'i18next'
import { PluralizationRulesMap } from './pluralization-rules'

export const pipePluralPostProcessor: PostProcessorModule = {
  name: 'pipePlural',
  type: 'postProcessor',
  process(value, _key, options, translator) {
    let index: number

    const SINGULAR_FORM = 0

    const PLURAL_FORM = 1

    const count = options.count

    if (typeof value !== 'string' || typeof count !== 'number') {
      return value
    }

    const splitTranslation = value.split('|').map((str) => str.trim())

    const lang = translator.language || 'en'

    const rule = new Intl.PluralRules(lang)

    const formOptions = rule.resolvedOptions().pluralCategories

    const pluralizationRule = PluralizationRulesMap.get(lang)

    const isSimplePluralization = formOptions.length === 2

    if (isSimplePluralization || !pluralizationRule) {
      index = count === 1 ? SINGULAR_FORM : PLURAL_FORM
    } else {
      index = pluralizationRule(count, formOptions.length)
    }

    const chosenForm = splitTranslation[index] ?? splitTranslation[splitTranslation.length - 1]

    return chosenForm.replace(/{count}/g, String(count))
  },
}
